import React, { FC, memo, useState } from 'react';
import ErrorMessage from '../errorMessage';
import { validateEmail } from '~/src/utils/validateEmail';
import s from './index.module.scss';
import locales from '../../../../../../../../../../content.json';
import classNames from 'classnames';

type Props = {
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, isValid: boolean) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement, Element>, isValid: boolean) => void;
  defaultValue?: string;
  className?: string;
  errorValidateText?: string;
};

const EmailField: FC<Props> = props => {
  const {
    className,
    placeholder = locales[window.userLang].enter_your_email,
    onChange,
    onBlur,
    defaultValue,
    errorValidateText = 'Your email address is invalid',
  } = props;
  const [error, setError] = useState<string>();
  const [empty, setEmpty] = useState<boolean | undefined>(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isValid = validateEmail(event.target.value);
    isValid && setError('');
    onChange && onChange(event, isValid);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement, Element>) => {
    setEmpty(false);
    !event.target.value && setError('');
    const isValid = validateEmail(event.target.value);
    !isValid && setError(errorValidateText);
    onBlur && onBlur(event, isValid);
  };

  return (
    <>
      <div className={`${s.emailWrapper} ${empty ? s.empty : ''}`}>
        {empty && (
          <span className={s.emailWrapper_title}>{locales[window.userLang].email}</span>
        )}
        <input
          className={classNames(s.email, error && s.error)}
          type="email"
          id="email"
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={() => setEmpty(true)}
          defaultValue={defaultValue}
        />
      </div>
      {error && <ErrorMessage error={error} />}
    </>
  );
};

export default memo(EmailField);
